import React from 'react';
import QuerySnippet from './QuerySnippet';

const LessonCard = ({ title, description, code }) => (
  <div className="card">
    <h2>{title}</h2>
    <p>{description}</p>
    {code && <QuerySnippet code={code} />}
  </div>
);

export default LessonCard;